(function(angular) {
    'use strict';

    angular.module('wtUi.services').factory('menuItemsFactory', function() {
        const that = this;
        that.itemsByState = that.itemsByState || {};

        // keeps the state of the menu items
        that.items = [];
        that.itemsByState = {};
        that.itemsById = {};

        function set(items) {
            that.items = items;
        }

        function getItemsByState() {
            if (Object.keys(that.itemsByState).length === 0) {
                createItemsBy(that.items, 'state', that.itemsByState);
            }
            return that.itemsByState;
        }

        function getItemsId() {
            if (Object.keys(that.itemsById).length === 0) {
                createItemsBy(that.items, 'id', that.itemsById);
            }
            return that.itemsById;
        }

        function createItemsBy(items, key, resultObj) {
            (items || []).forEach(function(child) {
                resultObj[child[key]] = child;

                if (child.children && child.children.length > 0) {
                    createItemsBy(child.children, key, resultObj);
                }
            });
        }

        function get() {
            return that.itemsByState;
        }

        return {
            set: set,
            get: get,
            getByState: getItemsByState,
            getById: getItemsId
        };
    });
})(window.angular);

